import React, { useEffect, useRef } from "react";
import CaseIcon from "./CaseIcon";
import Mathjax from "../common/Mathjax";

//export const bigCardWidth = 260;  // match BigCard.width in BigCard.js
//export const bigCardHeight = 310; // match BigCard.height in BigCard.js

export function BigCardOutline({ highlight, hideDragDrop, Dyn }) {
    return (
        <svg viewBox="0 0 260 310">
            <foreignObject width="260" height="310" x="0" y="0">
                <div
                    className={
                        "tde-drag-card tde-d-flex tde-align-center tde-border tde-py-2" +
                        (highlight ? " tde-highlight" : "")
                    }
                >
                    {!highlight && !hideDragDrop && (
                        <div className="tde-drag-box-circle tde-mx-auto tde-d-flex tde-align-center tde-text-center">
                            <p>{ Dyn.loc("Drag and Drop Card here") }</p>
                        </div>
                    )}
                    {highlight && (
                        <h3
                            className="tde-text-center tde-mx-auto"
                            style={{ fontSize: 24 }}
                        >
                            { Dyn.loc("Drop Here") }
                        </h3>
                    )}
                </div>
            </foreignObject>
        </svg>
    );
}

function BigCardView({ onClose, onEdit, onKeyPressed, Dyn, caseIndex, smallCardIndex, editable = false }) {
    const attribs = Dyn.dataSet.attribs;
    // Focus div after rendered
    const ref = useRef();
    useEffect(() => {
        ref?.current?.focus();
    }, [ref]);
    return (
        <svg viewBox="0 0 260 310">
            <foreignObject width="260" height="310" x="0" y="0">
                <div className="tde-big-card tde-border tde-py-2"
                    role="button"
                	onKeyDown={(e) => onKeyPressed(e)}
                    ref={ref}
                	tabIndex="0">
                    <div className="tde-d-flex tde-flex-items-center tde-pb-3 tde-px-2">
                        <div>
                            <CaseIcon Dyn={Dyn} />
                        </div>
                        <div className="tde-text-center tde-flex-1 tde-title">
                            <b>{ Dyn.loc("CARD {{n}}",{n: smallCardIndex + 1}) }</b>
                        </div>
                        {editable && (
                        <div className="tde-close-button tde-pt-1 tde-text-center tde-mr-2"
                            onClick={() => onEdit()}
                            onKeyDown={(e) => { if(e.key==="Enter") onEdit() }}
                            tabIndex="0"
                            role="button"
                        >
                            <i className="tde-i tde-i-pencil"></i>
                        </div>
                        )}
                        <div className="tde-close-button tde-pt-1 tde-text-center"
                            onClick={() => onClose()}
                            onKeyDown={(e) => { if(e.key==="Enter") onClose() }}
                            tabIndex="0"
                            role="button"
                        >
                            <i className="tde-i tde-i-remove"></i>
                        </div>
                    </div>
                    <table className="tde-mb-1" cellSpacing="0" style={{height:230, width: '100%'}}>
                        <tbody>
                            {attribs.slice(1).map((attrib, i) => (
                                <tr key={i}>
                                    <td
                                        width="50%"
                                        className={
                                            "tde-pl-3 tde-pr-2 tde-border-bottom tde-border-right" +
                                            (i === 0 ? " tde-border-top" : "")
                                        }
                                    >
                                        <b><Mathjax value={attrib.name} /></b>
                                    </td>
                                    <td
                                        width="50%"
                                        className={
                                            "tde-pl-2 tde-pr-3 tde-border-bottom" +
                                            (i === 0 ? " tde-border-top" : "")
                                        }
                                    >
                                        {attrib.caseValueToString(caseIndex)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </foreignObject>
        </svg>
    );
}

export default BigCardView;
